const FALLBACK = "Ocorreu um erro. Tenta novamente.";

/**
 * O texto de um erro de pedido, pronto a mostrar ao utilizador.
 *
 * O cliente HTTP (`lib/api.ts`) rejeita sempre um `Error` cuja `message` já é o `detail` que o servidor enviou
 * (ou a primeira mensagem de validação). Não tem `.response`: ler `error.response.data.detail` dá sempre
 * `undefined` e esconde o motivo real atrás de uma mensagem genérica.
 */
export function apiErrorMessage(error: unknown, fallback: string = FALLBACK): string {
  return error instanceof Error && error.message ? error.message : fallback;
}

type HttpErrorFields = { status?: number; detail?: unknown };

/** Estado HTTP do erro (`undefined` se não veio de uma resposta, p. ex. falha de rede). */
export function apiErrorStatus(error: unknown): number | undefined {
  return (error as HttpErrorFields | null)?.status;
}

/** O `detail` que o servidor enviou, tal como veio: texto, lista de validação (422) ou objeto estruturado. */
export function apiErrorDetail(error: unknown): unknown {
  return (error as HttpErrorFields | null)?.detail;
}
